<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <MapBox ref="mapBox" />
  </section>
</template>

<script>
import MapBox from './mapBox';
import {
  getEnumList,
  getDepartmentAllList,
} from 'api';
import {getOrgOptions} from '@qx/utils';
export default {
  components: {
    MapBox,
  },
  data () {
    return {
      searchBoxData: {
        orgIdOptions: [], // 归属部门
        vehicleClassOptions: [], // 车辆种类
        form: [
          { // 归属部门
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            default: -1,
            placeholder: '请选择归属部门',
          },
          { // 车辆种类
            label: '车辆种类',
            value: 'vehicleClass',
            type: 'select',
            default: -1,
            placeholder: '请选择车辆种类',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.mapBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...await getDepartmentAllList(),
    ];
    const enumsList = await getEnumList({
      codeType: 'VEHICLE_CLASS',
    });
    this.searchBoxData.vehicleClassOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
